import type { SectionBlock } from '@site/shared'
import { mapMedia } from './media'

/** Payload `sections` blocks → view-models. Unknown block types are dropped
 *  (the page still renders), so the CMS can add a block before the web app
 *  knows how to render it. */
export function mapBlocks(raw: unknown[], baseUrl: string): SectionBlock[] {
  return raw.flatMap((block): SectionBlock[] => {
    if (!block || typeof block !== 'object') return []
    const b = block as Record<string, unknown>

    switch (b.blockType) {
      case 'hero':
        return [{
          blockType: 'hero' as const,
          headline: (b.headline as string) ?? '',
          subheadline: (b.subheadline as string) || undefined,
          ctaLabel: (b.ctaLabel as string) || undefined,
          ctaHref: (b.ctaHref as string) || undefined,
          image: mapMedia(b.image as Record<string, unknown>, baseUrl),
        }]
      case 'cta':
        return [{
          blockType: 'cta' as const,
          headline: (b.headline as string) ?? '',
          subheadline: (b.subheadline as string) || undefined,
          buttonLabel: (b.buttonLabel as string) ?? '',
          buttonHref: (b.buttonHref as string) ?? '',
        }]
      case 'prose':
        return [{
          blockType: 'prose' as const,
          heading: (b.heading as string) || undefined,
          body: b.body,
        }]
      default:
        return []
    }
  })
}
